import BarChart from 'components/charts/barChart';
import events from 'lib/events';
import moment from 'moment';
import PrintableFullReport from '../../components/printableFullReport';
import React from 'react';
import ReportApi from 'api/report';
import Pagination from 'components/layout/pagination';
import {dateTimeFormats, trublueClaimStatuses, trublueClaimStatusesFormat, reportDateFormat, trublueClaimStatusIconId} from 'helpers/constants';
import {formatStaticCurrency} from 'helpers/currencyHelper';
import {formatCurrency} from 'helpers/dashboardFormatter';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import {trublueMemberIDEnabled} from 'features';

class TrublueClaimsSummary extends React.Component {
  static propTypes = {
    intl: intlShape.isRequired,
  };

  state = {};

  export = () => {
    let filters = this.props.filters;

    ReportApi.getWaterTrublueClaimsExport(
      this.props.intl.locale,
      filters.dateFrom,
      filters.dateTo,
      filters.search,
      filters.status,
    );
  };

  formatValue = (value, format) => {
    if (!value) {
      return '-';
    }
    return format ? format(value) : value;
  };

  statusClick = (id) => {
    return `/#trublueclaim/${id}`;
  };

  printReport() {
    const {filters, summary, POSActive} = this.props;
    let {formatMessage} = this.props.intl;
    let data = this.addCustomerName(this.props.data);

    const columns = [
      {name: formatMessage({id: 'trublue.claims.totalClaims'}), key: 'totalClaims'},
      {name: formatMessage({id: 'trublue.claims.openClaims'}), key: 'openClaims'},
      {name: formatMessage({id: 'trublue.claims.submittedClaims'}), key: 'submittedClaims'},
      {name: formatMessage({id: 'trublue.claims.approvedClaims'}), key: 'approvedClaims'},
      {name: formatMessage({id: 'trublue.claims.moreInformationClaims'}), key: 'moreInformationClaims'},
      {name: formatMessage({id: 'trublue.claims.dismissedClaims'}), key: 'dismissedClaims'},
      {name: formatMessage({id: 'trublue.claims.deniedClaims'}), key: 'deniedClaims'},
    ];

    let tableColumns = [
        {name: formatMessage({id: 'general.customer'}), key: 'customerName'},
        {name: formatMessage({id: 'general.alexid'}), key: 'AccountNo'},
    ];

    if(trublueMemberIDEnabled) {
      tableColumns.push({name: formatMessage({id: 'trublue.id'}), key: 'TruBlueMemberID'});
    }

    tableColumns.push({name: formatMessage({id: 'trublue.claims.watertest.date'}), key: 'AnalysisCreated'});
    tableColumns.push({name: formatMessage({id: 'trublue.claims.status'}), key: 'StatusID'});

    //   element.LastBioGuardPurchase = formatStaticCurrency(element.LastBioGuardPurchase);
    //   element.TotalPurchases = formatStaticCurrency(element.TotalPurchases);

    // data.AvgPurchasePerAccount = formatStaticCurrency(data.AvgPurchasePerAccount);
    //   {
    //     name: formatMessage({id: 'reports.last.water.analysis'}), key: 'LastAnalysisSystem', format: function(i) {
    //       return moment(i, 'MMM D YYYY  h:mmA').format(dateTimeFormats.numeralDate);
    //     },
    //   },

    return (
      <PrintableFullReport
        end={moment(filters.dateFrom).format(dateTimeFormats.numeralDate)}
        endLabel={formatMessage({id: 'general.end.date'})}
        formatMessage={formatMessage}
        start={moment(filters.dateTo).format(dateTimeFormats.numeralDate)}
        startLabel={formatMessage({id: 'general.start.date'})}
        summaryColumns={columns}
        summaryData={summary}
        tableColumns={tableColumns}
        tableData={data}
        title={formatMessage({id: 'trublue.claims.summary.report'})}
      />
    );
  };

  addCustomerName(data) {
    data.forEach((element) => {
      if(element.Contact && element.Contact.NameFirst) {
        element.customerName = element.Contact.NameFirst + ' ' + element.Contact.NameLast;
      } else if(element.Contact && element.Contact.ContactOrganization) {
        element.customerName = element.Contact.ContactOrganization;
      } else {
        element.customerName = '-';
      }
      element.AnalysisCreated = moment(element.AnalysisCreated).format(reportDateFormat);
      element.iconId = trublueClaimStatusIconId[element.StatusID];
      element.StatusID = trublueClaimStatusesFormat(this.props.intl.formatMessage)[element.StatusID] || element.StatusID;
    });
    return data;
  }

  render() {
    let summary = this.props.summary;
    let data = this.addCustomerName(this.props.data);
    let noData = Object.keys(data).length <= 0;
    let tableRows;
    let {formatMessage} = this.props.intl;

    tableRows = this.props.data.map((row, i) =>
      <tr key={i}
          className={i % 2 !== 0 ? 'gray-row' : ''}>
        <td>{row.customerName}</td>
        <td>{row.ID}</td>
        <td>{row.AccountNo}</td>
        {trublueMemberIDEnabled ? <td>{row.TruBlueMemberID}</td> : null}
        <td>{row.AnalysisCreated}</td>
        <td><i className={`bl ${row.iconId}`}/><a href={this.statusClick(row.ID)}>{row.StatusID}</a></td>
      </tr>,
    );

    return (
      <div>
        <div className="summary-container">
          <h2><FormattedMessage id="reports.report.summary"/></h2>
          <span className={Object.keys(data).length ? 'summary-date' : 'not-show'}> | <FormattedMessage id="general.date.range.labelled"
            values={{
              start: moment(this.props.filters.dateFrom)
                .format(dateTimeFormats.numeralDate),
              end: moment(this.props.filters.dateTo)
                .format(dateTimeFormats.numeralDate),
            }}/>
          </span>
          <br/>
          <span><FormattedMessage id="reports.reveal.report.summary"/></span>
          {this.props.showNoDataMessage ?
            <label className="report-no-data"><FormattedMessage id="reports.error.no.results"/></label> : ''}
          <div className="container-fluid custom-container-margins">
            <div className={Object.keys(data).length ? 'row' : 'not-show'}
                 id="row-no-padding">
              <div className='row'>
                <div className='col-sm-3 result'>
                  <label><FormattedMessage id='trublue.claims.totalClaims' /></label>
                  <div>{summary.totalClaims}</div>
                </div>
                <div className='col-sm-3 result'>
                  <label><FormattedMessage id='trublue.claims.openClaims' /></label>
                  <div>{summary.openClaims}</div>
                </div>
                <div className='col-sm-3 result'>
                  <label><FormattedMessage id='trublue.claims.submittedClaims' /></label>
                  <div>{summary.submittedClaims}</div>
                </div>
                <div className='col-sm-3 result'>
                  <label><FormattedMessage id='trublue.claims.approvedClaims' /></label>
                  <div>{summary.approvedClaims}</div>
                </div>
                <div className='col-sm-3 result'>
                  <label><FormattedMessage id='trublue.claims.moreInformationClaims' /></label>
                  <div>{summary.moreInformationClaims}</div>
                </div>
                <div className='col-sm-3 result'>
                  <label><FormattedMessage id='trublue.claims.dismissedClaims' /></label>
                  <div>{summary.dismissedClaims}</div>
                </div>
                <div className='col-sm-3 result'>
                  <label><FormattedMessage id='trublue.claims.deniedClaims' /></label>
                  <div>{summary.deniedClaims}</div>
                </div>
              </div>
              <table className="summary-table">
                <tbody>
                  <tr className="table-title">
                    <th className="bigger-row"><FormattedMessage id="general.customer"/></th>
                    <th><FormattedMessage id="trublue.claims.claim.id"/></th>
                    <th><FormattedMessage id="general.alexid"/></th>
                    {trublueMemberIDEnabled ? <th><FormattedMessage id="trublue.id"/></th> : null}
                    <th><FormattedMessage id="trublue.claims.watertest.date"/></th>
                    <th><FormattedMessage id="trublue.claims.status"/></th>
                  </tr>
                  {tableRows}
                </tbody>
              </table>
              <div className='center-pagination'>
                <Pagination
                  onPageChange={this.props.onPageChange}
                  page={this.props.page}
                  count={this.props.count}
                  total={this.props.total}/>
              </div>
            </div>
          </div>
        </div>
        <div className='col-sm-12 button-group'>
          <button className='btn btn-default pull-right'
                  disabled={Object.keys(data).length <= 0}
                  onClick={(() => {
                    events.publish('print', this.printReport(this.props.data));
                  })}><FormattedMessage id="reports.print.summary"/></button>
          <button className='btn btn-primary pull-right'
                  onClick={this.export}><FormattedMessage id="reports.export.report"/></button>
        </div>
      </div>
    );
  }
}

export default injectIntl(TrublueClaimsSummary);
